<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading || archiveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                {{ mode }} Member Category
            </h2>
            <div class="pb-0">
                <v-form name="memberCategoryEditForm" ref="memberCategoryEditForm">
                    <div class="tw-flex tw-mb-2">
                        <div class="tw-flex tw-flex-col tw-w-full tw-gap-4">
                            <v-autocomplete
                                v-model="modelObject.title_function_id"
                                :items="valuelists.TITLE_FUNCTIONS"
                                dense
                                clearable
                                color="primary"
                                label="Category"
                                display-label="Category"
                                :rules="[rules.required]"
                                hide-details="auto"
                                outlined
                            />
                            <v-text-field
                                :value="findValuelist(this.valuelists.DEPARTMENTS, modelObject.title_function_id)?.text"
                                label="Department"
                                hide-details="auto"
                                readonly
                                dense
                            ></v-text-field>
                            <date-picker
                                v-model="modelObject.created_at"
                                dense
                                color="primary"
                                label="Creation Date"
                                display-label="Creation Date"
                                hide-details="auto"
                            />
                            <v-btn
                              @click="makeHistory(modelProp)"
                              class="main-btn"
                              :loading="archiveLoading"
                              v-show="is_edit_mode"
                          >
                            Make History
                          </v-btn>
                            <v-radio-group
                                v-model="modelObject.default"
                                row
                            >
                                <v-radio
                                    v-for="(defaultOption, index) in valuelists.CATEGORY_DEFAULTS"
                                    :value="defaultOption.value"
                                    :key="defaultOption.value"
                                    :label="defaultOption?.text"
                                    color="primary"
                                    ref="defaultOptions"
                                    @click="unselectRadioButton($refs.defaultOptions[index])"
                                ></v-radio>
                            </v-radio-group>
                        </div>
                    </div>
                </v-form>
            </div>

            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3" >
                <v-btn
                    text
                    @click="archiveMemberCategory(modelProp)"
                    class="btn-solid"
                    :loading="archiveLoading"
                    v-show="is_edit_mode"
                >
                    Delete
                </v-btn>
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>

import DatePicker from "@/Generic/DatePicker.vue";
export default {
    name: "EditMemberCategoryModal",
    components: {DatePicker},
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true,
            default: function () {
                return undefined
            }
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'memberProp': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            // The valuelists we will rely on
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    updated() {
        //
    },
    data() {
        return {
            dialog: this.value || false,
            mode: '',
            modelObject: {},
            modelDefault: {
                title_function_id: null,
                user_id: this.memberProp.id,
                default: null,
                created_at: new Date().toISOString().split('T')[0],
            },
            saveLoading: false,
            archiveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
        }
    },
    mounted() {
        //
    },
    computed: {
        dialog_width() {
            return '500px'
        },
        is_edit_mode() {
            return this.mode === 'Edit' ? true : false
        },
    },
    methods: {
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        saveModel() {
            if (this.$refs.memberCategoryEditForm.validate()) {

                let formData = this.modelObject

                var url = ''
                var method = ''

                if( this.is_edit_mode ) {
                    url = route('membercategories.update', this.modelObject.id)
                    method = 'put'
                } else {
                    url = route('membercategories.store')
                    method = 'post'
                }

                axios({
                    method: method,
                    url: url,
                    data: formData,
                    onUploadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.saveLoading = false
                            this.$emit('successful-member-category-save')
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknow error.')
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                        } else {
                            console.log(error)
                            this.$root.snackbar.error(error)
                        }
                        this.saveLoading = false
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },
        async archiveMemberCategory(category)
        {
            if (await this.$root.confirm.open(`Delete Member Category`, `You are about to delete ${category?.title_function?.name}`)) {

                let method = 'delete'
                let url = route('membercategories.destroy', category.id)

                axios({
                    method: method,
                    url: url,
                    data: category,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Member Category has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$emit('successful-member-category-delete')
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        // this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        },
        async makeHistory(category)
        {
            if (await this.$root.confirm.open(`Make History`, `You are about to send ${category?.title_function?.name} to the historical categories`)) {

                let method = 'put'
                let url = route('membercategories.update', category.id)
                let payload = {
                    'is_historical': true,
                }

                axios({
                    method: method,
                    url: url,
                    data: payload,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Successfully Moved To History')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$emit('successful-member-category-save')
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        // this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        },
        findValuelist(list, id) {
            if (list && id) {
                return list.find(obj => obj.value === id)
            } else {
                return null
            }
        },
        getDeptDisplay() {

        },
        formatCreatedAt(date) {
            if (this.is_edit_mode) {
                return new Date(date).toISOString().split('T')[0]
            } else {
                return date
            }
        },
        unselectRadioButton(data) {
            if (data.isActive) {
                data.toggle()
                this.modelObject.default = null
            }
        }
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.$refs.memberCategoryEditForm.resetValidation()
            } else {
                // Opening modal
                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)
                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                }
            }
        },
        "modelObject.created_at"(newValue, oldValue) {
            this.modelObject.created_at = this.formatCreatedAt(newValue)
        }
    },
}

</script>

<style scoped>

</style>
